import { render, staticRenderFns } from "./ApplicationSlidebar.vue?vue&type=template&id=284abcf2"
import script from "./ApplicationSlidebar.vue?vue&type=script&lang=js"
export * from "./ApplicationSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports